var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLIntroImg3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 140C108.66 140 140 108.66 140 70C140 31.3401 108.66 0 70 0C31.3401 0 0 31.3401 0 70C0 108.66 31.3401 140 70 140Z",
    fill: "url(#paint0_linear_13152_63664)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13152_63664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.4328 40C61.2559 40.0047 60.303 40.9576 60.2983 42.1345V52.8613C60.2983 55.7213 64.5882 55.7213 64.5882 52.8613V44.2857H94.5756V95.7143H64.5882V89.2899C64.5882 86.43 60.2983 86.43 60.2983 89.2899V97.8655C60.303 99.0424 61.2559 99.9953 62.4328 100H96.731C97.9079 99.9953 98.8608 99.0424 98.8655 97.8655V42.1345C98.8608 40.9576 97.9079 40.0047 96.731 40H62.4328ZM42.9294 57.147C41.8333 57.2569 40.9989 58.1799 41 59.2815V82.853C40.9955 84.0429 41.9613 85.0087 43.1512 85.0042H71.0084C72.1918 84.9995 73.1474 84.0364 73.1429 82.853V79.894L82.9029 84.7656C84.3262 85.4771 86.001 84.4441 86.0042 82.853V59.2815C85.9999 58.0798 85.0083 57.1166 83.8069 57.147L73.1429 62.2405V59.2815C73.1382 58.1046 72.1853 57.1517 71.0084 57.147H42.9294ZM45.2857 61.4328H68.8572V80.7185H45.2857V61.4328ZM81.7185 62.7469V79.3876L73.1429 75.106V67.041L81.7185 62.7469ZM49.5798 63.5714C48.3964 63.5715 47.437 64.5308 47.437 65.7143C47.437 66.8977 48.3964 67.8571 49.5798 67.8571C50.7633 67.8571 51.7226 66.8977 51.7227 65.7143C51.7226 64.5308 50.7633 63.5715 49.5798 63.5714Z",
    fill: "#EDA42D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13152_63664",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEFD4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13152_63664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.8655,
    height: 60,
    fill: "white",
    transform: "translate(41 40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLIntroImg3);
export default __webpack_public_path__ + "static/media/l-intro-img-3.2724e17a9058276392ccb2bda2c692ef.svg";
export { ForwardRef as ReactComponent };